module.exports = __webpack_public_path__ + "img/thumbnail-cat.547f6e6c.jpg";